import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

export default function AddTopics() {
  const { profileId } = useParams();
  const navigate = useNavigate();

  const [topicData, setTopicData] = useState({
    topic_name: "",
    course_material: "",
    content: "",
  });

  const [videoFile, setVideoFile] = useState(null);

  useEffect(() => {
    const storedId = localStorage.getItem("selectedCourseMaterialId");
    if (storedId) {
      setTopicData((prev) => ({
        ...prev,
        course_material: parseInt(storedId)
      }));
    } else {
      alert("No course material selected. Please go back and select a course.");
      navigate(-1);
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTopicData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { files } = e.target;
    setVideoFile(files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("topic_name", topicData.topic_name);
    formData.append("course_material", topicData.course_material);
    formData.append("content", topicData.content);
    if (videoFile) formData.append("video_link", videoFile);

    try {
      await AxiosInstance.post("companies/topic/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      alert("Topic added successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Failed to add topic:", error);
      alert("Error adding topic.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal d-block als-trainer-portal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addTopicLabel"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addTopicLabel">Add Topic</h5>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-3">
                  <label className="form-label">Topic Name</label>
                  <input
                    type="text"
                    name="topic_name"
                    className="form-control"
                    value={topicData.topic_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Content</label>
                  <textarea
                    className="form-control"
                    name="content"
                    rows="6"
                    value={topicData.content}
                    onChange={handleChange}
                    placeholder="Write content here. Use '-' or '*' for bullets or separate paragraphs with new lines."
                    required
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label">Video File</label>
                  <input
                    type="file"
                    name="video_link"
                    className="form-control"
                    onChange={handleFileChange}
                    accept="video/*"
                  />
                </div>

                <div className="d-flex justify-content-end">
                  <button type="button" className="btn btn-secondary me-2" onClick={closeModal}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Topic
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
